import websockets from "./websockets";
import kore from "./kore";

export default { kore, websockets };
